<template>
  <span v-resize="checkMobile">
    <loading
      :active.sync="isLoading"
      :is-full-page="true"
      color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"
    ></loading>
    <!-- <v-flex md12>
        <h2>{{ $t('custom.analitics') }}</h2>
      </v-flex> -->
    <!-- <v-container class="text-center"> -->
      <!-- <v-layout> -->

      <v-toolbar
        text
        :color="$vuetify.theme.dark ? '' : 'white'"
        class="align-center"
      >
        <v-toolbar-title
          >{{ $t("analitics.common_workers") }} {{ $t("custom.number")
          }}{{ report.id }} {{ start_date_formatted }} -
          {{ end_date_formatted }} ({{ getBranchName() }})</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-checkbox
          v-model="with_not_active"
          :label="$t('analitics.show_unactive')"
          class="mt-5"
        ></v-checkbox>
        <v-btn
          color="primary"
          class="mr-2"
          icon
          @click="recalculateReport"
          :title="$t('analitics.recalculate')"
          :loading="isRecalculating"
          :disabled="isRecalculating || isGenerating"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-btn
          icon
          :href="docsLink('/analitika/otchyoty')"
          target="_blank"
        >
          <v-icon>mdi-help-circle</v-icon>
        </v-btn>
      </v-toolbar>
      
      <!-- Индикатор генерации отчета -->
      <v-flex v-if="isGenerating && !generationError" md12 class="mb-4 mt-4">
        <v-alert type="info" border="left" colored-border class="mb-4">
          <v-row align="center">
            <v-col class="grow">
              <div class="text-h6">{{ $t('analitics.report_generating') }}</div>
              <div class="text-caption">
                <span v-if="connected" class="success--text">● {{ $t('analitics.connected') }}</span>
                <span v-else class="error--text">● {{ $t('analitics.disconnected') }}</span>
              </div>
            </v-col>
          </v-row>
          <v-progress-linear :value="reportProgress" color="primary" height="20" class="mt-3" striped>
            <template v-slot:default><strong>{{ reportProgress.toFixed(0) }}%</strong></template>
          </v-progress-linear>
        </v-alert>
      </v-flex>
      
      <!-- Ошибка генерации отчета -->
      <v-flex v-if="generationError" md12 class="mb-4 mt-4">
        <v-alert type="error" border="left" colored-border class="mb-4">
          <v-row align="center">
            <v-col class="grow">
              <div class="text-h6">{{ $t('analitics.report_generation_error') }}</div>
              <div class="text-body-2 mt-2">{{ generationError }}</div>
            </v-col>
          </v-row>
          <v-btn color="error" outlined class="mt-3" @click="retryGeneration">
            <v-icon left>mdi-refresh</v-icon>
            {{ $t('analitics.try_again') }}
          </v-btn>
        </v-alert>
      </v-flex>
      
      <!-- Визуальная аналитика -->
      <v-card-text v-if="report.state == 'created' && showCharts">
        <v-expansion-panels v-model="chartsPanel" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <span class="subtitle-1 font-weight-medium">
                <v-icon left color="primary">mdi-chart-bar</v-icon>
                {{ $t("analitics.visual_analytics") }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <!-- Распределение рабочих дней -->
                <v-col cols="12" md="6" v-if="workDaysChartData && workDaysChartData.length > 1">
                  <!-- <h3 class="mb-3">{{ $t("analitics.work_days_distribution") }}</h3> -->
                  <GChart
                    style="width: 100%; min-height: 400px"
                    type="BarChart"
                    :options="workDaysChartOptions"
                    :settings="{
                      packages: ['corechart'],
                      language: this.$i18n.locale,
                    }"
                    :data="workDaysChartData"
                  />
                </v-col>

                <!-- Типы дней по всем работникам -->
                <v-col cols="12" md="6" v-if="daysTypesChartData && daysTypesChartData.length > 1">
                  <!-- <h3 class="mb-3">{{ $t("analitics.days_types_distribution") }}</h3> -->
                  <GChart
                    style="width: 100%; min-height: 400px"
                    type="PieChart"
                    :options="daysTypesChartOptions"
                    :settings="{
                      packages: ['corechart'],
                      language: this.$i18n.locale,
                    }"
                    :data="daysTypesChartData"
                  />
                </v-col>

                <!-- Топ по зарплатам -->
                <v-col cols="12" md="6" v-if="salariesChartData && salariesChartData.length > 1">
                  <!-- <h3 class="mb-3">{{ $t("analitics.top_salaries") }}</h3> -->
                  <GChart
                    style="width: 100%; min-height: 400px"
                    type="ColumnChart"
                    :options="salariesChartOptions"
                    :settings="{
                      packages: ['corechart'],
                      language: this.$i18n.locale,
                    }"
                    :data="salariesChartData"
                  />
                </v-col>

                <!-- Выдачи и приёмы -->
                <v-col cols="12" md="6" v-if="checkinsCheckoutsChartData && checkinsCheckoutsChartData.length > 1">
                  <!-- <h3 class="mb-3">{{ $t("analitics.checkins_checkouts") }}</h3> -->
                  <GChart
                    style="width: 100%; min-height: 400px"
                    type="ColumnChart"
                    :options="checkinsCheckoutsChartOptions"
                    :settings="{
                      packages: ['corechart'],
                      language: this.$i18n.locale,
                    }"
                    :data="checkinsCheckoutsChartData"
                  />
                </v-col>

                <!-- График 1: Платежи по созданным бронированиям -->
                <v-col cols="12" md="6" v-if="createdBookingsPaymentsChartData && createdBookingsPaymentsChartData.length > 1">
                  <!-- <h3 class="mb-3">{{ $t("analitics.payments_by_created_bookings") }}</h3> -->
                  <GChart
                    style="width: 100%; min-height: 400px"
                    type="ColumnChart"
                    :options="createdBookingsPaymentsChartOptions"
                    :settings="{
                      packages: ['corechart'],
                      language: this.$i18n.locale,
                    }"
                    :data="createdBookingsPaymentsChartData"
                  />
                </v-col>

                <!-- График 2: Платежи по выдачам/приемам -->
                <v-col cols="12" md="6" v-if="checkinCheckoutPaymentsChartData && checkinCheckoutPaymentsChartData.length > 1">
                  <!-- <h3 class="mb-3">{{ $t("analitics.payments_by_checkins_checkouts") }}</h3> -->
                  <GChart
                    style="width: 100%; min-height: 400px"
                    type="ColumnChart"
                    :options="checkinCheckoutPaymentsChartOptions"
                    :settings="{
                      packages: ['corechart'],
                      language: this.$i18n.locale,
                    }"
                    :data="checkinCheckoutPaymentsChartData"
                  />
                </v-col>

                <!-- График 3: Количество созданных бронирований (на всю ширину) -->
                <v-col cols="12" v-if="createdBookingsCountChartData && createdBookingsCountChartData.length > 1">
                  <GChart
                    style="width: 100%; min-height: 400px"
                    type="ColumnChart"
                    :options="createdBookingsCountChartOptions"
                    :settings="{
                      packages: ['corechart'],
                      language: this.$i18n.locale,
                    }"
                    :data="createdBookingsCountChartData"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>

      <!-- По компании -->
      <v-flex v-if="report.state == 'created'" md12>
        <v-data-table
          :class="!isMobile ? 'mt-5' : 'mt-5 is-mobile'"
          dense
          :headers="headers"
          :items="filtered_report"
          :loading="isLoading"
          :loading-text="$t('custom.loading_table')"
          :search="search"
          :items-per-page="50"
          :sort-by="['created_at']"
          mobile-breakpoint="100"
          :sort-desc="[true]"
          :footer-props="tableFooterProps([20, 50, 100, -1])"
        >
          <template slot="item" slot-scope="props">
            <tr
              :class="
                props.item.worker.active ? '' : 'grey--text text--lighten-1'
              "
            >
              <td nowrap class="text-center">{{ props.item.worker.name }}</td>
              <td nowrap class="text-center">{{ props.item.work_days }}</td>
              <td nowrap class="text-center">{{ props.item.holidays }}</td>
              <td nowrap class="text-center">{{ props.item.sick_days }}</td>
              <td nowrap class="text-center" data-testid="planned-hours-cell">{{ props.item.planned_hours != null ? props.item.planned_hours : 0 }}</td>
              <td nowrap class="text-center">{{ props.item.checkins }}</td>
              <td nowrap class="text-center">{{ props.item.checkouts }}</td>
              <td nowrap class="text-center">{{ getWorkerCreatedBookingsCount(props.item.worker.id) }}</td>
              <td nowrap class="text-center">{{ getWorkerPaymentsByCreatedBookings(props.item.worker.id) }}</td>
              <td nowrap class="text-center">{{ getWorkerPaymentsByCheckinsCheckouts(props.item.worker.id) }}</td>
              <td nowrap class="text-center">{{ props.item.salary }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex v-else md12 class="text-center mt-10">
        {{ $t("analitics.report_in_progress") }}
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
        <br />
        <v-btn @click="$router.go()">{{ $t("custom.update") }}</v-btn>
      </v-flex>
    <!-- </v-container> -->
  </span>
</template>
<script>
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
import { Capacitor } from "@capacitor/core";
import { GChart } from "vue-google-charts";
import CableSubscriber from "@/mixins/CableSubscriber";
export default {
  mixins: [CableSubscriber],
  components: {
    GChart,
  },
  pullToRefresh: true,
  data() {
    return {
      report: {},
      showCharts: false,
      chartsPanel: [0],
      headers: [
        { text: this.$t("check_lists.worker"), value: "name", align: "center" },
        {
          text: this.$t("analitics.work_days_for_worker"),
          value: "work_days",
          align: "center",
        },
        {
          text: this.$t("analitics.holidays_for_worker"),
          value: "holidays",
          align: "center",
        },
        {
          text: this.$t("analitics.sick_days_for_worker"),
          value: "sick_days",
          align: "center",
        },
        {
          text: this.$t("analitics.planned_hours_for_worker"),
          value: "planned_hours",
          align: "center",
        },
        {
          text: this.$t("analitics.checkins"),
          value: "checkins",
          align: "center",
        },
        {
          text: this.$t("analitics.checkouts"),
          value: "checkouts",
          align: "center",
        },
        {
          text: this.$t("analitics.created_bookings"),
          value: "created_bookings",
          align: "center",
        },
        { 
          text: this.$t("analitics.payments_created_bookings_short"), 
          value: "payments_created", 
          align: "center" 
        },
        { 
          text: this.$t("analitics.payments_checkins_checkouts_short"), 
          value: "payments_checkins", 
          align: "center" 
        },
        { text: this.$t("analitics.salary"), value: "salary", align: "center" },
      ],
      search: "",
      with_not_active: false,
      isMobile: false,
      isLoading: false,
      error: "",
      // WebSocket статус
      isGenerating: false,
      isRecalculating: false,
      connected: false,
      reportProgress: 0,
      generationError: null,
      // Данные о филиалах
      branches: [],
      current_branch_name: ''
    };
  },
  mounted() {
    let self = this;
  },
  beforeDestroy() {
    this.unsubscribeFromReport()
  },
  created() {
    setMomentLocale(this.$i18n.locale);
    if (
      this.$store.getters.isLoggedIn &&
      (this.$store.getters.isSuperAdmin ||
        this.$store.getters.isAdmin ||
        this.$store.getters.isGuest)
    ) {
      this.isLoading = true;
      this.loadReport();
    } else {
      this.$router.push({ path: `/dashboard` }).catch((err) => {});
      this.$notify(this.$t("errors.only_admins"), "", "warning", 5000);
    }
  },
  computed: {
    filtered_report() {
      let filtered_data = this.report.workers_data.filter((item) => {
        return item.worker.active == true;
      });
      if (this.with_not_active) {
        filtered_data = this.report.workers_data;
      }
      return filtered_data;
    },
    start_date_formatted() {
      return moment(this.report.start_date).format("DD.MM.YYYY");
    },
    end_date_formatted() {
      return moment(this.report.end_date).format("DD.MM.YYYY");
    },
    currency() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currency
      ) {
        return this.$store.getters.getCompany.company.currency;
      } else {
        return "";
      }
    },
    isIos() {
      return Capacitor.getPlatform().toLowerCase() == "ios" ? true : false;
    },
    // === Опции и данные для графиков ===
    workDaysChartOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.work_days_distribution"),
        chartArea: { width: "60%" },
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: { position: "none" },
        hAxis: {
          title: this.$t("analitics.work_days_for_worker"),
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
          titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        vAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        colors: ["#2196F3"],
      };
    },
    workDaysChartData() {
      if (!this.report.workers_data || this.report.workers_data.length === 0) return [];
      const data = [[this.$t("check_lists.worker"), this.$t("analitics.work_days_for_worker")]];
      const sorted = [...this.filtered_report]
        .filter(w => w.work_days > 0)
        .sort((a, b) => b.work_days - a.work_days)
        .slice(0, 15);
      sorted.forEach((item) => {
        data.push([item.worker.name, Number(item.work_days) || 0]);
      });
      return data;
    },
    daysTypesChartOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.days_types_distribution"),
        pieHole: 0.4,
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        colors: ["#4CAF50", "#FF9800", "#F44336"],
      };
    },
    daysTypesChartData() {
      if (!this.report.workers_data || this.report.workers_data.length === 0) return [];
      let totalWorkDays = 0;
      let totalHolidays = 0;
      let totalSickDays = 0;
      this.filtered_report.forEach((item) => {
        totalWorkDays += item.work_days || 0;
        totalHolidays += item.holidays || 0;
        totalSickDays += item.sick_days || 0;
      });
      return [
        [this.$t("custom.type"), this.$t("analitics.days")],
        [this.$t("analitics.work_days_for_worker"), totalWorkDays],
        [this.$t("analitics.holidays_for_worker"), totalHolidays],
        [this.$t("analitics.sick_days_for_worker"), totalSickDays],
      ];
    },
    salariesChartOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.top_salaries"),
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: { position: "none" },
        hAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        vAxis: {
          title: this.$t("analitics.salary"),
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
          titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        colors: ["#4CAF50"],
      };
    },
    salariesChartData() {
      if (!this.report.workers_data || this.report.workers_data.length === 0) return [];
      const data = [[this.$t("check_lists.worker"), this.$t("analitics.salary")]];
      const sorted = [...this.filtered_report]
        .filter(w => w.salary > 0)
        .sort((a, b) => b.salary - a.salary)
        .slice(0, 10);
      sorted.forEach((item) => {
        data.push([item.worker.name, parseFloat(item.salary)]);
      });
      return data;
    },
    checkinsCheckoutsChartOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.checkins_checkouts"),
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: {
          position: "top",
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        hAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        vAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
          titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        colors: ["#2196F3", "#FF9800"],
      };
    },
    checkinsCheckoutsChartData() {
      if (!this.report.workers_data || this.report.workers_data.length === 0) return [];
      const data = [
        [
          this.$t("check_lists.worker"),
          this.$t("analitics.checkins"),
          this.$t("analitics.checkouts"),
        ],
      ];
      const sorted = [...this.filtered_report]
        .filter(w => (w.checkins + w.checkouts) > 0)
        .sort((a, b) => (b.checkins + b.checkouts) - (a.checkins + a.checkouts))
        .slice(0, 10);
      sorted.forEach((item) => {
        data.push([item.worker.name, Number(item.checkins) || 0, Number(item.checkouts) || 0]);
      });
      return data;
    },
    // График 1: Платежи по созданным бронированиям
    createdBookingsPaymentsChartOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.payments_by_created_bookings"),
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: { position: "none" },
        hAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        vAxis: {
          title: this.currency,
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
          titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        colors: ["#FF9800"],
      };
    },
    createdBookingsPaymentsChartData() {
      if (!this.report.created_bookings_payments || this.report.created_bookings_payments.length === 0) return [];
      const data = [[this.$t("check_lists.worker"), this.$t("analitics.total_payments")]];
      const sorted = [...this.report.created_bookings_payments]
        .sort((a, b) => b.total_payments - a.total_payments)
        .slice(0, 15);
      sorted.forEach((item) => {
        data.push([item.worker_name, parseFloat(item.total_payments)]);
      });
      return data;
    },
    // График 2: Платежи по выдачам/приемам
    checkinCheckoutPaymentsChartOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.payments_by_checkins_checkouts"),
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: { position: "none" },
        hAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        vAxis: {
          title: this.currency,
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
          titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        colors: ["#9C27B0"],
      };
    },
    checkinCheckoutPaymentsChartData() {
      if (!this.report.checkin_checkout_payments || this.report.checkin_checkout_payments.length === 0) return [];
      const data = [[this.$t("check_lists.worker"), this.$t("analitics.total_payments")]];
      const sorted = [...this.report.checkin_checkout_payments]
        .sort((a, b) => b.total_payments - a.total_payments)
        .slice(0, 15);
      sorted.forEach((item) => {
        data.push([item.worker_name, parseFloat(item.total_payments)]);
      });
      return data;
    },
    // График 3: Количество созданных бронирований
    createdBookingsCountChartOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.created_bookings_distribution"),
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: { position: "none" },
        hAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        vAxis: {
          title: this.$t("analitics.bookings_count"),
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
          titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        colors: ["#00BCD4"],
      };
    },
    createdBookingsCountChartData() {
      if (!this.report.created_bookings_payments || this.report.created_bookings_payments.length === 0) return [];
      const data = [[this.$t("check_lists.worker"), this.$t("analitics.created_bookings")]];
      const sorted = [...this.report.created_bookings_payments]
        .sort((a, b) => (b.bookings_count || 0) - (a.bookings_count || 0))
        .slice(0, 20);
      sorted.forEach((item) => {
        data.push([item.worker_name, Number(item.bookings_count) || 0]);
      });
      return data;
    },
  },
  methods: {
    getBranchName() {
      if (this.report.all_branches) {
        return this.$t('custom.all_branches');
      }
      
      if (this.report.company_id) {
        const branch = this.branches.find(b => b.id === this.report.company_id);
        return branch ? branch.name : this.current_branch_name;
      }
      
      return this.current_branch_name;
    },
    loadReport() {
      this.axios
        .get(`/api/v1/workers_reports/${this.$route.params.query}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.report = response.data;
          this.branches = response.data.branches || [];
          this.current_branch_name = response.data.current_branch_name || '';
          if (this.report.state === 'initial' || this.report.state === 'pending') {
            this.isGenerating = true
            this.subscribeToReportUpdates()
          }
          if (response.data.state == "created") {
            this.showCharts = true;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.workers_report_load"));
          console.log(error);
          this.isLoading = false;
        });
    },
    // FT-066: ReportsChannel handlers (moved from the old channels option; this-rebinding via
    // arrows in subscribeToReportUpdates). Bodies are 1:1 with the former declarative channel.
    onReportConnected() {
      console.log('Connected to ReportsChannel for workers report')
      this.connected = true
    },
    onReportDisconnected() {
      console.log('Disconnected from ReportsChannel')
      this.connected = false
    },
    onReportReceived(data) {
      console.log('Report progress received:', data)

      if (data.report_id === this.report.id) {
        this.reportProgress = data.progress

        if (data.status === 'completed') {
          console.log('✅ Report generation completed!')
          this.isGenerating = false
          this.loadReport()

          this.$notify(
            this.$t('analitics.report_ready'),
            this.$t('analitics.report_generated_successfully'),
            'success',
            5000
          )
        }

        if (data.status === 'failed') {
          this.isGenerating = false
          this.generationError = data.error || this.$t('analitics.report_generation_failed')

          this.$notify(this.$t('errors.error'), this.generationError, 'error', 5000)
        }
      }
    },

    subscribeToReportUpdates() {
      if (this.report && this.report.id) {
        // FT-066 switch pattern: drop any prior sub before re-subscribing.
        this.$cableUnsubscribe(this.reportSub)
        this.reportSub = this.$cableSubscribe(
          {
            channel: 'ReportsChannel',
            report_type: 'workers',
            report_id: this.report.id
          },
          {
            connected: () => this.onReportConnected(),
            disconnected: () => this.onReportDisconnected(),
            received: (data) => this.onReportReceived(data)
          }
        )
        console.log('✅ Subscribed to ReportsChannel for workers report', this.report.id)
      }
    },
    unsubscribeFromReport() {
      this.$cableUnsubscribe(this.reportSub)
      this.reportSub = null
    },
    
    recalculateReport() {
      if (!this.report || !this.report.id || this.isRecalculating) {
        return
      }

      this.isRecalculating = true
      this.generationError = null
      this.isGenerating = true
      this.reportProgress = 0

      this.unsubscribeFromReport()

      this.axios
        .post(`/api/v1/workers_reports/${this.report.id}/recalculate`, {}, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then(() => {
          if (this.report) {
            this.report.state = 'pending'
          }
          this.subscribeToReportUpdates()
          this.$notify(
            this.$t('analitics.report_recalculation_started'),
            '',
            'success',
            3000
          )
        })
        .catch((error) => {
          this.isGenerating = false
          const message =
            (error.response && error.response?.data && error.response?.data.error) ||
            this.$t('analitics.report_recalculation_failed')
          let localizedMessage = message
          if (message === 'Report is already being processed') {
            localizedMessage = this.$t('analitics.report_already_processing')
          }
          this.generationError = localizedMessage
          this.$notify(this.$t('errors.error'), localizedMessage, 'error', 5000)
        })
        .finally(() => {
          this.isRecalculating = false
        })
    },

    retryGeneration() {
      // Сбрасываем ошибку и перезагружаем отчет
      this.generationError = null
      this.isGenerating = true
      this.reportProgress = 0
      this.loadReport()
    },
    
    getWorkerCreatedBookingsCount(workerId) {
      if (!this.report.created_bookings_payments || this.report.created_bookings_payments.length === 0) {
        return '-';
      }
      const report_data = this.report.created_bookings_payments.filter(p => p.worker_id === workerId);
      let bookings_count = 0;
      if (report_data && report_data.length > 0) {
        bookings_count = report_data[0].bookings_count;
      }
      return bookings_count;
    },
    
    getWorkerPaymentsByCreatedBookings(workerId) {
      if (!this.report.created_bookings_payments || this.report.created_bookings_payments.length === 0) {
        return '-';
      }
      const payment = this.report.created_bookings_payments.find(p => p.worker_id === workerId);
      return payment ? parseFloat(payment.total_payments).toFixed(2) : '-';
    },
    
    getWorkerPaymentsByCheckinsCheckouts(workerId) {
      if (!this.report.checkin_checkout_payments || this.report.checkin_checkout_payments.length === 0) {
        return '-';
      }
      const payment = this.report.checkin_checkout_payments.find(p => p.worker_id === workerId);
      return payment ? parseFloat(payment.total_payments).toFixed(2) : '-';
    },
    
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
  },
};
</script>
